import script from "./ButtonPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonPoints.vue?vue&type=script&setup=true&lang=js"

import "./ButtonPoints.vue?vue&type=style&index=0&id=40242b9a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40242b9a"]])

export default __exports__